import moment from 'moment'

export const reportSalesPeriod = {
    startDate : moment().format('YYYY-MM-DD'),
    toDate: moment().format('YYYY-MM-DD'),
    customerId: ''
}

export const reportIncome = {
    startDate : moment().format('YYYY-MM-DD'),
    toDate: moment().format('YYYY-MM-DD'),
    memberId: '',
    role: 'doctor',
}

export const reportExpense = {
    startDate : moment().format('YYYY-MM-DD'),
    toDate: moment().format('YYYY-MM-DD'),
    expenseId: ''
}

export const reportSupplies = {
    startDate : moment().format('YYYY-MM-DD'),
    toDate: moment().format('YYYY-MM-DD'),
    suppliesId: ''
}